var React = require('react');

function ArrowScroll (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"arrow-scroll","fill":"none","strokeWidth":"10","d":"M 0,0 L100,100 L200,0"}));
}

ArrowScroll.defaultProps = {"viewBox":"0 20 200 100"};

module.exports = ArrowScroll;

ArrowScroll.default = ArrowScroll;
